module.exports = __webpack_public_path__ + "static/zoomuslin-9011152113e6c21bc297f97456f0b5da.jpeg";